export const getNameById = (array: any[], id: any) => array.find((item: { id: any; }) => item.id === id)?.matchID;

 
